var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-title",on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_vm._t("default",null,{"attrs":"$attrs"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }